// export const getTraceroute = result => {
//   if (result) {
//     const sortedRoutList = result.routList.sort((a, b) => a.hop - b.hop);
//
//     return `${result.description}\n\n${sortedRoutList
//       .map(
//         route =>
//           `${route.hop} ${route.ip} ${
//             route.responseTimes.length > 0
//               ? `${route.responseTimes.join("ms ")}ms`
//               : ""
//           }`,
//       )
//       .join(" ")}\n\n${
//       Object.keys(result?.countryAndIpMap).length !== 0
//         ? "Package route by countriesConstant\n" +
//           Object.entries(result.countryAndIpMap)
//             .map(route =>
//               route[1] !== "local local" ? `${route[1]}: ${route[0]}` : "",
//             )
//             .filter(Boolean)
//             .join("\n")
//         : ""
//     }`;
//   }
//
//   return "";
// };

export const getTraceroute = result => {
  if (!result) return "";

  const sortedRoutList = result.routList.sort((a, b) => a.hop - b.hop);

  const routingDetails = sortedRoutList
    .map(route => {
      const responseTimes =
        route.responseTimes.length > 0
          ? `${route.responseTimes.join("ms ")}ms`
          : "*"; // If there is no response time
      const ipAddress = route.ip || "*"; // If there is no IP, substitute `*`

      // If both parts are missing, leave only one asterisk
      if (ipAddress === "*" && responseTimes === "*") {
        return `${route.hop} *`;
      }

      return `${route.hop} ${ipAddress} ${responseTimes}`;
    })
    .join("\n"); // Separate routes with line breaks

  // logic for the route by country
  const countryDetails =
    Object.keys(result?.countryAndIpMap).length !== 0
      ? "\nPackage route by countriesConstant\n" +
        Object.entries(result.countryAndIpMap)
          .map(route =>
            route[1] !== "local local" ? `${route[1]}: ${route[0]}` : "",
          )
          .filter(Boolean)
          .join("\n")
      : "";

  return `${result.description}\n\n${routingDetails}${countryDetails}`;
};
